// src/services/api/suggestions.ts

import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import { SuggestionRequest, SuggestionResponse } from '../../types/suggestion';

/**
 * 生成即時建議
 * @param request - 建議請求參數
 * @returns Promise<SuggestionResponse> - 建議回應
 */
export const generateImmediateSuggestions = async (
  request: SuggestionRequest
): Promise<SuggestionResponse> => {
  try {
    const generateSuggestionFn = httpsCallable(functions, 'generateImmediateSuggestion');
    
    console.log('調用 AI 建議 API，參數:', request);
    
    const result = await generateSuggestionFn(request);
    const data = result.data as SuggestionResponse;
    
    console.log('AI 建議 API 回應:', data);
    
    if (!data.success) {
      throw new Error('建議生成失敗');
    }
    
    return data;
    
  } catch (error) {
    console.error('生成 AI 建議失敗:', error);
    
    // 處理不同類型的錯誤
    if (error instanceof Error) {
      throw new Error(`建議生成失敗: ${error.message}`);
    }
    
    throw new Error('建議生成失敗: 未知錯誤');
  }
};